// extracted by mini-css-extract-plugin
export default {"outerDiv":"DownloadAppModal_outerDiv__FAfZl","innerDiv":"DownloadAppModal_innerDiv__O9wfN"};